import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@/shared/ui";
import useGoogleCode from "@/domains/playerMenu/hooks/useGoogleCode";
import useGameSettings from "@/domains/settings/hooks/useGameSettings";
import PlayerMenuSettingsSafetyEnableTfaAuthenticatorCheckContainer from "@/domains/playerMenu/containers/settings/safety/tfa/check-enable/PlayerMenuSettingsSafetyEnableTfaAuthenticatorCheckContainer";

type Props = {
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyEnableTfaAuthenticatorContainer({
  onClose,
}: Props) {
  const { t } = useTranslation("account");
  const { getGameSettings } = useGameSettings();
  const [authCode, setAuthCode] = useState("");
  const {
    checkCodeHandler,
    checkIsPending,
    checkError,
    authenticator,
    getAuthenticatorHandler,
    checkIsCompleted,
  } = useGoogleCode();

  const onSubmit = useCallback(async () => {
    checkCodeHandler(authCode);
  }, [authCode]);

  useEffect(() => {
    getAuthenticatorHandler();
  }, []);

  useEffect(() => {
    if (checkIsCompleted) {
      getGameSettings();
      onClose();
    }
  }, [checkIsCompleted, onClose]);

  if (checkIsCompleted) {
    return null;
  }

  return (
    <Modal open onClose={onClose} title={t("account.enableTfaGoogle")} className="h-[49rem]">
      <PlayerMenuSettingsSafetyEnableTfaAuthenticatorCheckContainer
        error={checkError}
        code={authCode}
        onCodeChange={setAuthCode}
        onSubmit={onSubmit}
        pending={checkIsPending}
        qr={authenticator ? authenticator.qrCodeBase64 : ""}
        backupCode={authenticator ? authenticator.backupCode : ""}
      />
    </Modal>
  );
}
